import styleInject from '../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".secure-description.wcl-1r2w7a3{margin:0 0 30px 0;width:100%;max-width:654px;text-align:center}.border.wcl-1r2w7a3{width:100%;border-top:1px solid rgba(255, 255, 255, 0.2)}.secure-hint.wcl-1r2w7a3{margin:0 0 25px 0;color:rgba(255, 255, 255, 0.6)}.secure-action.wcl-1r2w7a3{padding:25px 0 0 0;text-align:center;width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.secure-action.wcl-1r2w7a3 .tile-button{min-width:175px;box-sizing:border-box}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=ThreeDS.css.js.map
